import LandingNav from '@/pages/landing/LandingNav';
import HeroSection from '@/pages/landing/HeroSection';
import ProblemCallout from '@/pages/landing/ProblemCallout';
import HowItWorks from '@/pages/landing/HowItWorks';
import FeatureGrid from '@/pages/landing/FeatureGrid';
import PersonaCards from '@/pages/landing/PersonaCards';
import TrustSection from '@/pages/landing/TrustSection';
import DisclaimerPanel from '@/pages/landing/DisclaimerPanel';
import FAQ from '@/pages/landing/FAQ';
import FinalCTA from '@/pages/landing/FinalCTA';
import LandingFooter from '@/pages/landing/LandingFooter';

export default function LandingPage() {
  return (
    <div className="min-h-screen" data-testid="landing-page">
      <LandingNav />
      <main>
        <HeroSection />
        <ProblemCallout />
        <HowItWorks />
        <FeatureGrid />
        <PersonaCards />
        <TrustSection />
        <DisclaimerPanel />
        <FAQ />
        <FinalCTA />
      </main>
      <LandingFooter />
    </div>
  );
}
